module.exports = __webpack_public_path__ + "img/Japan.ab2e13c6.png";